module.exports = __webpack_public_path__ + "img/xuchang2.68e07298.png";